<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- header -->
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2">
        <div class="row breadcrumbs-top">
          <div class="col-lg-9">
            <h2 class="content-header-title mb-0">{{ contentHeader.headerTitle | translate }}</h2>
            <app-breadcrumb *ngIf="contentHeader?.breadcrumb?.links.length > 0" [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
          </div>
          <div class="col-lg-3 text-right pt-1">
            <input type="search" [placeholder]="'SEARCH_FEATURE_OPTION' | translate" class="form-control" [(ngModel)]="searchFeaturOption" (ngModelChange)="onSearchFeatureOption()" />
          </div>
        </div>
      </div>
    </div>
    <!-- inizio delle card -->
    <div class="row" id="cards-container">
      <div class="col-lg-4">
        <!--liste-->
        <div class="card" *ngIf="pages.lists.length > 0">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'list'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "LISTS" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075" *ngFor="let pageItem of pages.lists">
              <a *ngIf="!pageItem.click" [routerLink]="pageItem.url">{{ pageItem.label | translate }}</a>
              <a *ngIf="pageItem.click" (click)="pageItem.click()" class="text-primary">{{ pageItem.label | translate }}</a>
            </div>
          </div>
        </div>
        <!--diritti utente-->
        <div class="card" *ngIf="pages.user_permissions.length > 0">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'shield'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "MENU.CAPABILITY_USER" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075" *ngFor="let pageItem of pages.user_permissions">
              <a *ngIf="!pageItem.click" [routerLink]="pageItem.url">{{ pageItem.label | translate }}</a>
              <a *ngIf="pageItem.click" (click)="pageItem.click()" class="text-primary">{{ pageItem.label | translate }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <!--aggiornamento dati-->
        <div class="card" *ngIf="pages.update_data.length > 0">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'database'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "MENU.UPDATE_DATA" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075" *ngFor="let pageItem of pages.update_data">
              <a *ngIf="!pageItem.click" [routerLink]="pageItem.url">{{ pageItem.label | translate }}</a>
              <a *ngIf="pageItem.click" (click)="pageItem.click()" class="text-primary">{{ pageItem.label | translate }}</a>
            </div>
          </div>
        </div>
        <!--amministrazione-->
        <div class="card" *ngIf="pages.administration.length > 0">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'folder'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "MENU.ADMINISTRATION" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075" *ngFor="let pageItem of pages.administration">
              <a *ngIf="!pageItem.click" [routerLink]="pageItem.url">{{ pageItem.label | translate }}</a>
              <a *ngIf="pageItem.click" (click)="pageItem.click()" class="text-primary">{{ pageItem.label | translate }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <!--fatture-->
        <div class="card" *ngIf="pages.invoice.length > 0">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'dollar-sign'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "MENU.INVOICES" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075" *ngFor="let pageItem of pages.invoice">
              <a *ngIf="!pageItem.click" [routerLink]="pageItem.url">{{ pageItem.label | translate }}</a>
              <a *ngIf="pageItem.click" (click)="pageItem.click()" class="text-primary">{{ pageItem.label | translate }}</a>
            </div>
          </div>
        </div>
        <!--Notifiche & comunicazioni-->
        <div class="card" *ngIf="pages.notifications.length > 0">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'bell'" size="19" class="mr-05"></span>
            <div class="card-title">
              {{ "MENU.NOTIFICATIONS" | translate }} & <span class="text-lowercase">{{ "MENU.COMMUNICATIONS" | translate }}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="mb-075" *ngFor="let pageItem of pages.notifications">
              <a *ngIf="!pageItem.click" [routerLink]="pageItem.url">{{ pageItem.label | translate }}</a>
              <a *ngIf="pageItem.click" (click)="pageItem.click()" class="text-primary">{{ pageItem.label | translate }}</a>
            </div>
          </div>
        </div>
        <!--documenti-->
        <div class="card" *ngIf="pages.documents.length > 0">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'file-text'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "MENU.MANAGE_DOCUMENTS" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075" *ngFor="let pageItem of pages.documents">
              <a *ngIf="!pageItem.click" [routerLink]="pageItem.url">{{ pageItem.label | translate }}</a>
              <a *ngIf="pageItem.click" (click)="pageItem.click()" class="text-primary">{{ pageItem.label | translate }}</a>
            </div>
          </div>
        </div>

        <!--gestione piattaforma-->
        <div class="card" *ngIf="pages.manage_platform.length > 0">
          <div class="card-header align-items-center justify-content-start">
            <span [data-feather]="'grid'" size="19" class="mr-05"></span>
            <div class="card-title">{{ "PLATFORM_MANAGEMENT" | translate }}</div>
          </div>
          <div class="card-body">
            <div class="mb-075" *ngFor="let pageItem of pages.manage_platform">
              <a *ngIf="!pageItem.click" [routerLink]="pageItem.url">{{ pageItem.label | translate }}</a>
              <a *ngIf="pageItem.click" (click)="pageItem.click()" class="text-primary">{{ pageItem.label | translate }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #setAMaintenance let-modal>
  <form (ngSubmit)="setMaintenance(); modalClose()">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modalClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" [formGroup]="formGroup">
      <h3 class="mb-1">{{ "SET_A_MAINTENANCE" | translate }}</h3>
      <div class="row">
        <div class="form-group col-6 mb-1">
          <label for="day_from">{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
          <ng2-flatpickr id="day_from" [ngClass]="'day_from'" [config]="optionFrom" formControlName="day_from"></ng2-flatpickr>
        </div>
        <div class="form-group col-6 mb-1">
          <label for="hour_from">{{ "HOUR_TO" | translate }}<sup class="text-danger">*</sup></label>
          <ngb-timepicker id="hour_from" formControlName="hour_from" [spinners]="false"></ngb-timepicker>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-6 mb-1">
          <label for="day_to">{{ "TO" | translate }}<sup class="text-danger">*</sup></label>
          <ng2-flatpickr id="day_to" [ngClass]="'day_to'" [config]="optionTo" formControlName="day_to"></ng2-flatpickr>
        </div>
        <div class="form-group col-6 mb-1">
          <label for="hour_to">{{ "HOUR_TO" | translate }}<sup class="text-danger">*</sup></label>
          <ngb-timepicker id="hour_to" formControlName="hour_to" [spinners]="false"></ngb-timepicker>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()" rippleEffect>
        {{ "CANCEL" | translate }}
      </button>
      <button type="submit" class="btn btn-primary w-150" rippleEffect>
        {{ "SEND" | translate }}
      </button>
    </div>
  </form>
</ng-template>

<ng-template #clearCache let-modal>
  <div class="modal-header">
    <button type="button" class="close" (click)="modalClose()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h3 class="mb-1">{{ "CLEAR_CACHE" | translate }}</h3>
    <p>{{ "CLEAR_CACHE_EXPLICATION" | translate }}</p>
    <div class="row">
      <div class="form-group col mb-1">
        <input type="text" class="form-control" [(ngModel)]="urlClearCache" [placeholder]="'INSERT_END_POINT_URL' | translate" />
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button [disabled]="isSubmitting" (click)="clearTheCache()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #refreshAnalytics let-modal>
  <div class="modal-header">
    <button type="button" class="close" (click)="modalClose()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h3 class="mb-1">{{ "REGENERATE_ANALYTICS" | translate }}</h3>
    <p>{{ "REGENERATE_MONTLY_AND_YEARLY_ANALYTICS" | translate }}</p>
      <div class="row">
        <div class="form-group col mb-1">
          <label>{{ "MONTH" | translate | titlecase }}</label>
          <select [(ngModel)]="monthToReload" class="form-control">
            <option *ngFor="let month of months; let i = index" [value]="i+1">{{ month | titlecase}}</option>
          </select>
        </div>
        <div class="form-group col mb-1">
          <label>{{ "YEAR" | translate | titlecase }}</label>
          <input type="number" class="form-control" min="2023" [(ngModel)]="yearToReload">
        </div>
      </div>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button [disabled]="isSubmitting" (click)="reloadAnalytics()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "SEND" | translate }}
    </button>
  </div>
</ng-template>
